import URL from 'url-parse';
import JSONSerializable from 'lib/serialization/json-serializable';
import { computed } from 'mobx';
import { ApiItem } from 'lib/api/api-item';

export { WPAttachment };

@JSONSerializable()
class WPAttachment extends ApiItem {
    photoSwipeItem = () => {
        const {
            mediaDetails: { height, width },
        } = this;
        return {
            w: width,
            h: height,
            msrc: this.mediaDetails.sizes.medium.sourceUrl,
            src: this.guid.rendered,
            title: this.caption.rendered,
        };
    };

    @computed get alt() {
        return this.altText || '';
    }

    @computed get src() {
        let src;

        if (this.srcSet) {
            const split = this.srcSet.split(',');
            let previousWidth = 0;

            for (let i = 0; i < split.length; i++) {
                const part = split[i];
                const [href, widthString] = part.split(' ');

                const width = parseInt(widthString.replace('w', ''), 10);

                if (width && width > previousWidth && width <= 768) {
                    src = href;
                }

                previousWidth = width;
            }
        }

        if (src) {
            return src;
        }

        return this.sourceUrl || '';
    }

    @computed get srcSet() {
        if (!this.mediaDetails || !this.sourceUrl) {
            return null;
        }

        const {
            mediaDetails: { sizes },
            sourceUrl,
        } = this;
        const split = sourceUrl.split('/');

        split.pop();

        const basename = split.join('/');
        const srcSet = new Set();

        Object.keys(sizes).forEach(key => {
            const { file, width } = sizes[key];
            if (/[0-9]+x[0-9]+\..+$/.test(file)) {
                srcSet.add(`${basename}/${file} ${width}w`);
            }
        });

        return Array.from(srcSet).join(',');
    }
}
